<!--
 * @Description: 子账户设置
 * @Date: 2019-12-28 12:47:46
 * @LastEditTime: 2020-03-18 16:55:09
 -->

<template>
  <div id="setAccount" v-loading="detail.loading">
    <div class="content-wrap">
      <h3 class="title">
        账户设置
      </h3>
      <el-form
        ref="form"
        :model="form"
        :rules="rules"
        label-width="94px"
        autocomplete="off"
      >
        <el-form-item prop="orgName" label="企业名称">
          <el-input
            v-model="form.orgName"
            type="text"
            disabled
            @blur="handleSubmit"
          />
        </el-form-item>
        <el-form-item class="account" prop="username" label="账号">
          <el-input
            v-model="form.username"
            type="text"
            disabled
          />
          <el-button type="text" @click="linkTo('/setPsd')">
            修改密码
          </el-button>
        </el-form-item>
        <el-form-item prop="email" label="邮箱">
          <el-input
            v-model="form.email"
            type="text"
            disabled
          />
        </el-form-item>
        <el-form-item prop="userType" label="账户类型">
          <el-input
            v-model="form.userType"
            type="text"
            disabled
          />
        </el-form-item>
        <el-form-item prop="userType" label="小程序码">
          <img :src="detail.data.miniProgramCode" alt="小程序码" title="点击预览" @click="handlePreviewImg">
        </el-form-item>
      </el-form>
    </div>
    <!-- 图片预览 -->
    <PreviewImg ref="preview" />
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { validateOrgName, validateContectName } from '@/utils/validator'
import { PreviewImg } from '@/components'
import { getCanvas } from '@/utils/tools'

export default {
  components: { PreviewImg },
  data() {
    return {
      form: {
        orgName: '',
        username: '',
        email: '',
        userType: ''
      },
      imgUrl: '',
      rules: {
        orgName: [{ validator: validateOrgName, trigger: 'change' }],
        contactName: [{ validator: validateContectName, trigger: 'change' }]
      }
    };
  },
  computed: {
    ...mapState({
      detail: state => state.account.detail
    })
  },
  mounted() {
    this.getDetail().then(res => {
      Object.keys(this.form).forEach(key => {
        this.form[key] = res[key] || ''
      })
    })
  },
  methods: {
    ...mapActions({
      getDetail: 'account/getDetail',
      setAccount: 'account/setAccount'
    }),
    // 提交
    handleSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.setAccount(this.form).then(res => {
            this.$message({
              type: 'success',
              message: '修改成功',
              center: true
            })
          })
        }
      });
    },
    // 图片预览
    handlePreviewImg(row) {
      const image = new Image()
      image.src = this.detail.data.miniProgramCode
      image.onload = async () =>{
        this.imgUrl = await getCanvas(image,image.width,image.height)
        this.$refs.preview.src = this.imgUrl
        this.$refs.preview.visible = true
      }
    }
  }
};
</script>
<style lang="scss">
@import '../../assets/scss/variable.scss';

#setAccount {
  .content-wrap {
    width: 400px;
    margin: 0 auto;
    padding-top: 50px;
    transform: translateX(-45px);
    .title {
      padding: 40px 0 40px 90px;
      text-align: center;
      font-size: 20px;
      color: $fontColor2;
    }
    .account {
      position: relative;
      .el-button {
        position: absolute;
        right: -68px;
        top: 0;
        z-index: 2;
      }
    }
    .el-form {
      img {
        width: 100px;
        height: 100px;
        border: solid 1px #efefef;
        cursor: pointer;
      }
    }
    .el-form-item.is-success .el-input__inner,
    .el-form-item.is-success .el-input__inner:focus,
    .el-form-item.is-success .el-textarea__inner,
    .el-form-item.is-success .el-textarea__inner:focus {
      border-color: #dcdfe6;
    }
  }
}
</style>
